import { withTranslation } from 'react-i18next';
import OpenBanking from './OpenBanking.layout';

export default withTranslation('open-banking')(OpenBanking);
